export const baseURL = 'https://roboclubserver.iitd.ac.in';
export const ogip = 'http://10.10.12.252:4180';